"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.cellNode = void 0;
const formulaEngineUtils = __importStar(require("../../../utils"));
// Cell represents a variable that should exist on the JS object being evaluated as input
exports.cellNode = {
    hasChildNodes: false,
    getEvaluatorFunction: ({ node, buildContext }) => {
        const variableName = formulaEngineUtils.getNodeContent(node);
        const isRangeVariable = formulaEngineUtils.isRangeVariable(variableName);
        if (isRangeVariable) {
            buildContext.rangeVariables.add(variableName);
        }
        else {
            buildContext.rowVariables.add(variableName);
        }
        return ({ rowVariables, rangeVariables }) => {
            // ----- Range variable (always flattened key) -----
            if (isRangeVariable) {
                const result = rangeVariables.get(variableName);
                if (result) {
                    return {
                        node,
                        inputs: [],
                        output: { error: null, result },
                    };
                }
                return {
                    node,
                    inputs: [],
                    output: {
                        error: `Range value for property ${formulaEngineUtils.extractVariableNameFromRange(variableName)} was not provided`,
                    },
                };
            }
            // ----- Row variable -----
            // Handles both flattened and object forms
            const property = formulaEngineUtils.getProperty(rowVariables, variableName);
            if (property.error) {
                return {
                    node,
                    inputs: [],
                    output: { error: `Unable to find variable:'${variableName}'` },
                };
            }
            return {
                node,
                inputs: [],
                output: { error: null, result: property.value },
            };
        };
    },
};
//# sourceMappingURL=cell.js.map